const reviews = {
  // Page titles
  title: 'التقييمات',
  myReviews: 'تقييماتي',
  writeReview: 'اكتب تقييماً',

  // Review form
  form: {
    title: 'اكتب تقييمك',
    ratingLabel: 'تقييمك',
    ratingRequired: 'يرجى اختيار تقييم',
    commentLabel: 'تعليقك',
    commentPlaceholder: 'شاركنا تجربتك...',
    commentOptional: '(اختياري)',
    photoLabel: 'إضافة صور',
    photoOptional: '(اختياري)',
    anonymousLabel: 'نشر بشكل مجهول',
    anonymousDescription: 'لن يظهر اسمك مع التقييم',
    submit: 'إرسال التقييم',
    submitting: 'جاري الإرسال...',
    success: 'تم إرسال تقييمك بنجاح',
    error: 'فشل إرسال التقييم',
  },

  // Rating labels
  ratings: {
    1: 'سيء جداً',
    2: 'سيء',
    3: 'متوسط',
    4: 'جيد',
    5: 'ممتاز',
  },

  // Review display
  display: {
    verifiedReview: 'تقييم موثّق',
    helpfulCount: 'وجد {{count}} شخص هذا مفيداً',
    helpful: 'مفيد',
    report: 'إبلاغ',
    reply: 'رد',
    edited: 'معدّل',
    anonymous: 'مجهول',
  },

  // Summary
  summary: {
    title: 'ملخص التقييمات',
    averageRating: 'متوسط التقييم',
    totalReviews: 'إجمالي التقييمات',
    ratingDistribution: 'توزيع التقييمات',
    stars: 'نجوم',
    star: 'نجمة',
  },

  // Filters and sorting
  filters: {
    all: 'الكل',
    withPhotos: 'مع صور',
    verified: 'موثّقة فقط',
    sortBy: 'ترتيب حسب',
    newest: 'الأحدث',
    oldest: 'الأقدم',
    highest: 'الأعلى تقييماً',
    lowest: 'الأقل تقييماً',
    mostHelpful: 'الأكثر فائدة',
  },

  // Report
  report: {
    title: 'الإبلاغ عن تقييم',
    reason: 'سبب الإبلاغ',
    reasons: {
      spam: 'محتوى مزعج',
      inappropriate: 'محتوى غير لائق',
      fake: 'تقييم مزيف',
      offensive: 'محتوى مسيء',
      other: 'سبب آخر',
    },
    details: 'تفاصيل إضافية',
    detailsPlaceholder: 'اشرح سبب الإبلاغ...',
    submit: 'إرسال البلاغ',
    success: 'تم إرسال البلاغ بنجاح',
    error: 'فشل إرسال البلاغ',
  },

  // Empty states
  noReviews: 'لا توجد تقييمات',
  noReviewsDescription: 'كن أول من يكتب تقييماً',
  noReviewsYet: 'لم يتم تقييمك بعد',

  // Broker reviews
  broker: {
    reviewBroker: 'قيّم الوسيط',
    afterDeal: 'بعد إتمام الصفقة',
    howWasExperience: 'كيف كانت تجربتك مع هذا الوسيط؟',
    responseTime: 'سرعة الرد',
    professionalism: 'الاحترافية',
    knowledge: 'المعرفة',
    communication: 'التواصل',
    overall: 'التقييم العام',
  },

  // Property reviews
  property: {
    reviewProperty: 'قيّم العقار',
    howWasProperty: 'كيف كان هذا العقار؟',
    accuracy: 'دقة الوصف',
    location: 'الموقع',
    value: 'القيمة مقابل السعر',
    condition: 'حالة العقار',
  },
  // عنوان التقييمات التفصيلية (BrokerRatingSummary)، كما يظهر في الصفحة.
  categoryRatings: 'التقييمات التفصيلية',
};

export default reviews;
